(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PointDetailController', PointDetailController);

    PointDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Point', 'AlertService'];

    function PointDetailController($scope, $rootScope, $stateParams, previousState, entity, Point, AlertService) {
        var vm = this;

        vm.point = entity;
        vm.previousState = previousState.name;
        vm.adaptInterventions = adaptInterventions;

        var unsubscribe = $rootScope.$on('tmgApp:pointUpdate', function(event, result) {
            vm.point = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function adaptInterventions() {
            Point.adaptInterventions({id: vm.point.id}, function onSuccess() {
            }, function onError(error) {
                AlertService.error('Erreur lors de l\'adaptation des interventions: ' + error.data.message);
            });
        }
    }
})();
